import en from './en.entrance.json';

export const entrance = {
  en,
};
